import { render, staticRenderFns } from "./DescargoCorPage.vue?vue&type=template&id=14f68e2b"
import script from "./DescargoCorPage.js?vue&type=script&lang=js&external"
export * from "./DescargoCorPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports